import dayjs from "dayjs";
// CHECK AGE
export const checkAge = (year) => {
  const now = dayjs();

  const convertNow = dayjs(now).format("YYYY");
  return Number(convertNow) - Number(year);
};
